module.exports = __webpack_public_path__ + "img/beast1.32b18380.png";